<template>
  <div class="container">
    <a-breadcrumb style="padding: 16px 0; background: #f0f2f5">
      <a-breadcrumb-item>微信小程序</a-breadcrumb-item>
      <a-breadcrumb-item>微信支付</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="mainBox" style="padding: 24px">
      <div style="width: 80%; margin: 0px auto">
			
			<a-form-model ref="batchForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
				<div class="form-title">微信支付</div>
				<a-form-model-item label="商户号">
					<a-input v-model="tmp.mchid" style="width: 400px" />
				</a-form-model-item>
				<a-form-model-item label="密钥">
					<a-input v-model="tmp.mchkey" style="width: 400px" />
				</a-form-model-item>
        <div class="form-title">证书</div>
				<a-form-model-item label="cert文件">
					<a-upload
            name="file"
            :multiple="true"
            :customRequest="customRequest"
            :showUploadList="false"
            @change="changeFile($event, 1)"
          >
            <a-button> <a-icon type="upload" /> 选择文件 </a-button>
          </a-upload>
          <div v-if="tmp.apiclient_cert">已上传：{{ tmp.apiclient_cert }}</div>
				</a-form-model-item>
        <a-form-model-item label="key文件">
					<a-upload
            name="file"
            :multiple="true"
            :customRequest="customRequest"
            :showUploadList="false"
            @change="changeFile($event, 2)"
          >
            <a-button> <a-icon type="upload" /> 选择文件 </a-button>
          </a-upload>
          <div v-if="tmp.apiclient_key">已上传：{{ tmp.apiclient_key }}</div>
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 3 }">
					<a-button type="primary" @click="formSubmit" :loading="loading"> 提交 </a-button>
				</a-form-model-item>
			</a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  payConfigDetail,
  payConfigEdit,
  payConfigPemUpload,
} from "@/request/api";
import VDistpicker from "v-distpicker";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {

  },
  data () {
    return {
      tmp: {
        mchid: undefined,
        mchkey: undefined,
        apiclient_cert: undefined,
        apiclient_key: undefined
      },
      loading: false,
      uploadType: 1,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getPayConfig () {
      payConfigDetail().then((res) => {
        this.tmp = res.data.result;
      });
    },
    //上传文件
    changeFile (info, t) {
      this.uploadType = t
    },
    //上传组件自定义上传方式
    customRequest (data) {
      const formData = new FormData();
      formData.append('file',data.file);
      payConfigPemUpload(formData)
        .then((res) => {
          if(res.data.code==200){
            if(this.uploadType==1){
              this.tmp.apiclient_cert = res.data.result.filename;
            }else{
              this.tmp.apiclient_key = res.data.result.filename;
            }
          }else{
            this.$message.error(res.data.message?res.data.message:'上传失败');
          }
        });
    },
    formSubmit(){
      this.loading = true
      payConfigEdit(this.tmp).then((res) => {
        if(res.data.result.id){
          this.$message.success("保存成功");
        }
      }).finally(()=>{
        this.loading = false
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getPayConfig();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
  beforeCreate () { }, //生命周期 - 创建之前
  beforeMount () { }, //生命周期 - 挂载之前
  beforeUpdate () { }, //生命周期 - 更新之前
  updated () { }, //生命周期 - 更新之后
  beforeDestroy () { }, //生命周期 - 销毁之前
  destroyed () { }, //生命周期 - 销毁完成
  activated () { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.controlBox {
  display: flex;
  .btn {
    margin-bottom: 10px;
    margin-right: 20px;
  }
}
.e-space {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.form-title{
	font-weight: 900;
	padding:12px 0 12px 20px;
}
</style>